import React from 'react';
import AdminSettingsComponent from '../../components/admin/AdminSettings';

const AdminSettings = () => {
  return <AdminSettingsComponent />;
};

export default AdminSettings;
